import type { AnyRouter } from '@tanstack/react-router';

export interface RouteSnapshot {
  pathname: string;
  params: Record<string, unknown>;
}

let previous: RouteSnapshot | null = null;

export const trackNavigationOrigin = (router: AnyRouter): (() => void) => {
  previous = null;
  const unsubscribe = router.subscribe(
    'onBeforeNavigate',
    ({ fromLocation, pathChanged }) => {
      if (!fromLocation || !pathChanged) return;
      previous = {
        pathname: fromLocation.pathname,
        params: router.state.matches.at(-1)?.params ?? {},
      };
    },
  );
  return () => {
    unsubscribe();
    previous = null;
  };
};

export const getPreviousRoute = (): RouteSnapshot | null => previous;
